import { ELEMENT_SHAPE } from "constants/enums"
import * as React from "react"
import { IIconProps } from "./IIcon"

export function Icon({
    name,
    color,
    bgColor = "none",
    size = 24,
    shape = ELEMENT_SHAPE.ROUNDED_SQUARE,
    onClick,
}: IIconProps) {
    const bgColorValue = { backgroundColor: bgColor }
    return (
        <div
            className={`a-icon-box ${shape}`}
            style={{ ...bgColorValue, color: color }}
            onClick={onClick}
        >
            {renderIcon(name, color, size)}
        </div>
    )
}

const renderIcon = (
    name: string,
    color = "#071A53",
    size?: string | number
) => {
    switch (name) {
        case "email":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-mail-opened"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="m3 9 9 6 9-6-9-6-9 6" fill="rgba(7, 26, 83, .2)" />
                    <path d="M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9M3 19l6-6M15 13l6 6" />
                </svg>
            )
        case "bell":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-bell"
                    width={size}
                    height={size}
                    viewBox={`0 0 24 24`}
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="5" r="2" fill="#F16F6F" stroke="none" />
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="M10 5a2 2 0 0 1 4 0 7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 4-6M9 17v1a3 3 0 0 0 6 0v-1" />
                    <circle
                        cx="12"
                        cy="19"
                        r="2"
                        fill="#CDD1DD"
                        stroke="none"
                    />
                </svg>
            )
        case "logo-white":
            return (
                <svg
                    width="211"
                    height="27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#a)" style={{ padding: 20 }}>
                        <path
                            d="M18.427 13.321 10.565 27 0 0c6.529 16.688 15.574 14.423 17.591 13.673l.838-.352h-.002Z"
                            fill="url(#b)"
                        />
                        <path
                            d="M36 27c-6.512-16.64-15.521-14.437-17.573-13.679l-.838.352L25.435 0 36 27Z"
                            fill="url(#c)"
                        />
                    </g>
                    <path
                        d="m57.912 18-3.528-9.338H51.36L47.846 18h2.618l.476-1.414h3.878L55.294 18h2.618Zm-3.724-3.444H51.57l1.302-3.794 1.316 3.794ZM65.238 18V8.662h-2.142v3.374c-.546-.672-1.26-.966-2.002-.966-1.694 0-2.996 1.33-2.996 3.542 0 2.296 1.33 3.556 2.996 3.556.756 0 1.442-.308 2.002-.952V18h2.142Zm-2.142-2.352c-.28.364-.84.616-1.302.616-.854 0-1.484-.644-1.484-1.652s.63-1.638 1.484-1.638c.462 0 1.022.238 1.302.602v2.072ZM70.849 18l2.66-6.762h-2.282l-1.54 4.284-1.526-4.284h-2.268L68.553 18h2.296Zm9.456 0v-4.228c0-2.1-1.526-2.702-3.15-2.702-1.036 0-2.198.308-3.066 1.05l.77 1.358a3.016 3.016 0 0 1 1.918-.714c.868 0 1.372.392 1.372.98v.854c-.406-.504-1.204-.784-2.1-.784-1.036 0-2.324.49-2.324 2.128 0 1.526 1.288 2.226 2.324 2.226.868 0 1.68-.336 2.1-.84V18h2.156Zm-2.156-1.736c-.224.322-.728.49-1.204.49-.574 0-1.078-.252-1.078-.784s.504-.784 1.078-.784c.476 0 .98.168 1.204.476v.602ZM88.604 18v-4.788c0-1.246-.7-2.142-2.24-2.142-1.134 0-1.932.518-2.338.994v-.826H81.87V18h2.156v-4.368c.252-.308.672-.658 1.316-.658.672 0 1.106.294 1.106 1.12V18h2.156Zm1.117-3.388c0 2.128 1.582 3.556 3.696 3.556 1.456 0 2.366-.658 2.772-1.246l-1.4-1.316c-.266.378-.7.658-1.274.658-.896 0-1.582-.63-1.582-1.652 0-1.022.686-1.638 1.582-1.638.574 0 1.008.252 1.274.644l1.4-1.302c-.406-.602-1.316-1.246-2.772-1.246-2.114 0-3.696 1.428-3.696 3.542Zm7 0c0 2.198 1.61 3.556 3.696 3.556 1.036 0 2.156-.294 2.828-.896l-.91-1.344c-.378.336-1.05.574-1.652.574-1.008 0-1.596-.574-1.722-1.204h4.816v-.462c0-2.296-1.456-3.766-3.458-3.766-2.114 0-3.598 1.582-3.598 3.542Zm3.598-1.876c.994 0 1.344.686 1.4 1.162h-2.786c.084-.49.448-1.162 1.386-1.162ZM111.531 18V8.662h-2.142v3.374c-.546-.672-1.26-.966-2.002-.966-1.694 0-2.996 1.33-2.996 3.542 0 2.296 1.33 3.556 2.996 3.556.756 0 1.442-.308 2.002-.952V18h2.142Zm-2.142-2.352c-.28.364-.84.616-1.302.616-.854 0-1.484-.644-1.484-1.652s.63-1.638 1.484-1.638c.462 0 1.022.238 1.302.602v2.072Zm7.163 1.036c.714.868 1.876 1.484 3.416 1.484 2.52 0 3.318-1.442 3.318-2.646 0-1.89-1.652-2.366-3.164-2.8-1.274-.336-2.436-.658-2.436-1.764 0-1.008.938-1.722 2.184-1.722 1.05 0 2.002.364 2.674 1.176l.532-.588c-.728-.826-1.764-1.316-3.164-1.316-1.694 0-3.066.966-3.066 2.492 0 1.722 1.568 2.142 3.038 2.548 1.316.35 2.562.714 2.562 2.03 0 .798-.546 1.862-2.464 1.862-1.33 0-2.31-.658-2.912-1.358l-.518.602Zm9.835 1.484c.56 0 .882-.168 1.148-.42l-.28-.56a1.056 1.056 0 0 1-.756.322c-.476 0-.7-.378-.7-.924v-4.704h1.372v-.644h-1.372V9.39h-.742v1.848h-1.12v.644h1.12v4.816c0 .924.434 1.47 1.33 1.47Zm5.242 0c2.002 0 3.262-1.582 3.262-3.556s-1.26-3.542-3.262-3.542c-1.974 0-3.248 1.568-3.248 3.542 0 1.974 1.274 3.556 3.248 3.556Zm0-.658c-1.568 0-2.464-1.386-2.464-2.898 0-1.498.896-2.884 2.464-2.884 1.596 0 2.478 1.386 2.478 2.884 0 1.512-.882 2.898-2.478 2.898Zm5.87.49v-4.928c.308-.588 1.232-1.204 1.918-1.204.14 0 .238 0 .364.028v-.798c-.938 0-1.708.546-2.282 1.302v-1.162h-.728V18h.728Zm3.323-3.388c0 2.086 1.414 3.556 3.388 3.556 1.12 0 1.974-.392 2.646-1.092l-.378-.476c-.574.616-1.358.938-2.212.938-1.596 0-2.576-1.218-2.646-2.688h5.656v-.196c0-1.946-1.134-3.584-3.192-3.584-1.876 0-3.262 1.582-3.262 3.542Zm3.248-2.912c1.694 0 2.45 1.428 2.464 2.576h-4.914c.056-1.176.854-2.576 2.45-2.576Zm17.447 6.3-3.528-9.338h-3.024L151.451 18h2.618l.476-1.414h3.878l.476 1.414h2.618Zm-3.724-3.444h-2.618l1.302-3.794 1.316 3.794ZM168.885 18v-4.788c0-1.246-.7-2.142-2.24-2.142-1.134 0-1.932.518-2.338.994v-.826h-2.156V18h2.156v-4.368c.252-.308.672-.658 1.316-.658.672 0 1.106.294 1.106 1.12V18h2.156Zm7.711 0v-4.228c0-2.1-1.526-2.702-3.15-2.702-1.036 0-2.198.308-3.066 1.05l.77 1.358a3.016 3.016 0 0 1 1.918-.714c.868 0 1.372.392 1.372.98v.854c-.406-.504-1.204-.784-2.1-.784-1.036 0-2.324.49-2.324 2.128 0 1.526 1.288 2.226 2.324 2.226.868 0 1.68-.336 2.1-.84V18h2.156Zm-2.156-1.736c-.224.322-.728.49-1.204.49-.574 0-1.078-.252-1.078-.784s.504-.784 1.078-.784c.476 0 .98.168 1.204.476v.602ZM180.317 18V8.662h-2.156V18h2.156Zm1.423 2.632c.224.07.728.112.924.112 1.288-.028 2.31-.35 2.856-1.778l3.052-7.728h-2.282l-1.54 4.284-1.526-4.284h-2.268l2.688 6.86-.154.364c-.112.28-.42.378-.91.378-.168 0-.378-.042-.532-.126l-.308 1.918Zm10.044-2.464c.798 0 1.33-.196 1.596-.448l-.42-1.624c-.07.084-.308.168-.546.168-.379 0-.602-.294-.602-.686v-2.464h1.372v-1.876h-1.372V9.39h-2.142v1.848h-1.12v1.876h1.12v3.066c0 1.302.742 1.988 2.114 1.988Zm3.56-7.784c.686 0 1.232-.546 1.232-1.232 0-.686-.546-1.232-1.232-1.232-.686 0-1.232.546-1.232 1.232 0 .686.546 1.232 1.232 1.232ZM196.422 18v-6.762h-2.156V18h2.156Zm1.115-3.388c0 2.128 1.582 3.556 3.696 3.556 1.456 0 2.366-.658 2.772-1.246l-1.4-1.316c-.266.378-.7.658-1.274.658-.896 0-1.582-.63-1.582-1.652 0-1.022.686-1.638 1.582-1.638.574 0 1.008.252 1.274.644l1.4-1.302c-.406-.602-1.316-1.246-2.772-1.246-2.114 0-3.696 1.428-3.696 3.542Zm6.874 2.52c.714.63 1.96 1.036 3.164 1.036 1.946 0 3.08-.952 3.08-2.24 0-1.792-1.708-2.072-2.856-2.268-.714-.126-1.078-.238-1.078-.546 0-.294.35-.462.854-.462.812 0 1.582.35 1.988.742l.826-1.428c-.728-.532-1.694-.896-2.828-.896-1.876 0-2.898 1.036-2.898 2.226 0 1.722 1.624 1.96 2.772 2.156.7.112 1.162.238 1.162.588 0 .294-.266.504-.91.504-.798 0-1.876-.448-2.38-.896l-.896 1.484Z"
                        fill="#fff"
                    />
                    <defs>
                        <linearGradient
                            id="b"
                            x1="0"
                            y1="13.499"
                            x2="18.427"
                            y2="13.499"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#fff" stopOpacity=".6" />
                            <stop offset="1" stopColor="#fff" />
                        </linearGradient>
                        <linearGradient
                            id="c"
                            x1="17.591"
                            y1="13.499"
                            x2="36"
                            y2="13.499"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#fff" />
                            <stop
                                offset="1"
                                stopColor="#fff"
                                stopOpacity=".6"
                            />
                        </linearGradient>
                        <clipPath id="a">
                            <path fill="#fff" d="M0 0h36v27H0z" />
                        </clipPath>
                    </defs>
                </svg>
            )
        case "search":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-search"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="10" cy="10" r="7" />
                    <path d="m21 21-6-6" />
                </svg>
            )
        case "sort-desc":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-arrow-narrow-down"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="16" y1="15" x2="12" y2="19" />
                    <line x1="8" y1="15" x2="12" y2="19" />
                </svg>
            )
        case "sort-asc":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-arrow-narrow-up"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="16" y1="9" x2="12" y2="5" />
                    <line x1="8" y1="9" x2="12" y2="5" />
                </svg>
            )
        case "sort":
            return (
                <svg
                    width={size}
                    height={size}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g fill="none" fillRule="evenodd">
                        <path fill="none" d="M-130-99h1440v700H-130z" />
                        <g
                            stroke="#9C9FA9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M1 .857h6M1 6h6M1 11.143h7.714M10.429 3.429L13" />
                        </g>
                    </g>
                </svg>
            )

        case "trash":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-trash"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#6C78B2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="4" y1="7" x2="20" y2="7" />
                    <line x1="10" y1="11" x2="10" y2="17" />
                    <line x1="14" y1="11" x2="14" y2="17" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
            )
        case "edit":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-pencil"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#6C78B2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4" />
                    <line x1="13.5" y1="6.5" x2="17.5" y2="10.5" />
                </svg>
            )
        case "password":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-eye-check"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="12" cy="12" r="2" />
                    <path d="M12 19c-4 0-7.333-2.333-10-7 2.667-4.667 6-7 10-7s7.333 2.333 10 7c-.42.736-.858 1.414-1.311 2.033M15 19l2 2 4-4" />
                </svg>
            )
        case "text":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-eye-off"
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    strokeWidth="1"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="m3 3 18 18M10.584 10.587a2 2 0 0 0 2.828 2.83" />
                    <path d="M9.363 5.365A9.466 9.466 0 0 1 12 5c4 0 7.333 2.333 10 7-.778 1.361-1.612 2.524-2.503 3.488m-2.14 1.861C15.726 18.449 13.942 19 12 19c-4 0-7.333-2.333-10-7 1.369-2.395 2.913-4.175 4.632-5.341" />
                </svg>
            )
        case "chevron-left":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chevron-left"
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M15 6L9 12L15 18" stroke="currentColor" />
                </svg>
            )
        case "chevron-right":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chevron-right"
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M9 6L15 12L9 18" stroke="currentColor" />
                </svg>
            )
        case "close":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-square-x"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 10l4 4m0 -4l-4 4" />
                </svg>
            )
        case "noUser":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-user-circle"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="12" cy="12" r="9" />
                    <circle cx="12" cy="10" r="3" />
                    <path d="M6.168 18.849A4 4 0 0 1 10 16h4a4 4 0 0 1 3.834 2.855" />
                </svg>
            )
        case "chevron-down":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chevron-down"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="m6 9 6 6 6-6" />
                </svg>
            )
        case "chevron-up":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={size}
                    height={size}
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    className="icon icon-tabler icon-tabler-chevron-up"
                    viewBox="0 0 24 24"
                >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="m6 15 6-6 6 6" />
                </svg>
            )
        case "filter":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-adjustments-horizontal"
                    width="20"
                    height="20"
                    strokeWidth="1.5"
                    stroke={color}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="14" cy="6" r="2" />
                    <path d="M4 6h8M16 6h4" />
                    <circle cx="8" cy="12" r="2" />
                    <path d="M4 12h2M10 12h10" />
                    <circle cx="17" cy="18" r="2" />
                    <path d="M4 18h11M19 18h1" />
                </svg>
            )
        case "plus-circle":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-circle-plus"
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#F4F5FC"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="9" y1="12" x2="15" y2="12" />
                    <line x1="12" y1="9" x2="12" y2="15" />
                </svg>
            )

        case "company":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-building-skyscraper"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="3" y1="21" x2="21" y2="21" />
                    <path
                        d="M5 21v-14l8 -4v18"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <path d="M19 21v-10l-6 -4" />
                    <line x1="9" y1="9" x2="9" y2="9.01" />
                    <line x1="9" y1="12" x2="9" y2="12.01" />
                    <line x1="9" y1="15" x2="9" y2="15.01" />
                    <line x1="9" y1="18" x2="9" y2="18.01" />
                </svg>
            )
        case "people":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-users"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle
                        cx="9"
                        cy="7"
                        r="4"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                </svg>
            )
        case "dashboard":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chart-radar"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 3l9.5 7l-3.5 11h-12l-3.5 -11z" />
                    <path
                        d="M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <path d="M2.5 10l9.5 3l9.5 -3" />
                    <path d="M12 3v10l6 8" />
                    <path d="M6 21l6 -8" />
                </svg>
            )
        case "reports":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-file-analytics"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                    <line x1="9" y1="17" x2="9" y2="12" />
                    <line x1="12" y1="17" x2="12" y2="16" />
                    <line x1="15" y1="17" x2="15" y2="14" />
                </svg>
            )
        case "camera":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-device-computer-camera"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="10" r="7" stroke="#ffffff" />
                    <circle
                        cx="12"
                        cy="10"
                        r="3"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <path
                        d="M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
                        fill="rgba(120, 106, 171, .4)"
                    />
                </svg>
            )
        case "location-route":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-route"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle
                        cx="6"
                        cy="19"
                        r="2"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <circle
                        cx="18"
                        cy="5"
                        r="2"
                        fill="rgba(149, 135, 201, .4)"
                    />
                    <path d="M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5" />
                </svg>
            )
        case "map-pin":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-map-pin"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="11" r="3" />
                    <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                </svg>
            )

        case "city":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-building"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="3" y1="21" x2="21" y2="21" />
                    <line x1="9" y1="8" x2="10" y2="8" />
                    <line x1="9" y1="12" x2="10" y2="12" />
                    <line x1="9" y1="16" x2="10" y2="16" />
                    <line x1="14" y1="8" x2="15" y2="8" />
                    <line x1="14" y1="12" x2="15" y2="12" />
                    <line x1="14" y1="16" x2="15" y2="16" />
                    <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
                </svg>
            )
        case "country":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-world"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="9" />
                    <line x1="3.6" y1="9" x2="20.4" y2="9" />
                    <line x1="3.6" y1="15" x2="20.4" y2="15" />
                    <path d="M11.5 3a17 17 0 0 0 0 18" />
                    <path d="M12.5 3a17 17 0 0 1 0 18" />
                </svg>
            )
        case "workingTime":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-calendar-time"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" />
                    <circle cx="18" cy="18" r="4" />
                    <path d="M15 3v4" />
                    <path d="M7 3v4" />
                    <path d="M3 11h16" />
                    <path d="M18 16.496v1.504l1 1" />
                </svg>
            )
        case "upload":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-file-upload"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.2"
                    stroke="#9e9e9e"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zM12 11v6" />
                    <path d="m9 14 3-3 3 3" />
                </svg>
            )
        case "gate":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-building-arch"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="M3 21h18M4 21V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15" />
                    <path d="M9 21v-8a3 3 0 0 1 6 0v8" />
                </svg>
            )
        case "compare":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-git-compare"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="6" cy="6" r="2" />
                    <circle cx="18" cy="18" r="2" />
                    <path d="M11 6h5a2 2 0 0 1 2 2v8" />
                    <path d="m14 9-3-3 3-3M13 18H8a2 2 0 0 1-2-2V8" />
                    <path d="m10 15 3 3-3 3" />
                </svg>
            )
        case "address-sign":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-at"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#d3cdfb"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="4" />
                    <path d="M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28" />
                </svg>
            )
        case "download":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-download"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                    <polyline points="7 11 12 16 17 11" />
                    <line x1="12" y1="4" x2="12" y2="16" />
                </svg>
            )
        case "user":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-user"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#5138ee"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="7" r="4" />
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                </svg>
            )
        case "mailing-report":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-mail-forward"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <path d="M12 18H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7.5" />
                    <path d="m3 6 9 6 9-6M15 18h6M18 15l3 3-3 3" />
                </svg>
            )
        case "tech-support":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-headset"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <rect x="4" y="13" rx="2" width="4" height="6" />
                    <rect x="16" y="13" rx="2" width="4" height="6" />
                    <path d="M4 15v-3a8 8 0 0 1 16 0v3" />
                    <path d="M18 19a6 3 0 0 1 -6 3" />
                </svg>
            )

        case "translate":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-letter-case"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M0 0h24v24H0z" stroke="none" />
                    <circle cx="17.5" cy="15.5" r="3.5" />
                    <path d="M3 19V8.5a3.5 3.5 0 0 1 7 0V19M3 13h7M21 12v7" />
                </svg>
            )
        case "clock":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-clock"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#ffffff"
                    fill="#66C07F"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="9" stroke="none" />
                    <polyline points="12 7 12 12 15 15" />
                </svg>
            )
        case "clock-red":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-clock"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#ffffff"
                    fill="#F86156"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="9" stroke="none" />
                    <polyline points="12 7 12 12 15 15" />
                </svg>
            )
        case "chart-area":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chart-area-line"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#FEB32D"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <polyline
                        points="4 19 8 13 12 15 16 10 20 14 20 19 4 19"
                        fill="#FEB32D"
                    />
                    <polyline points="4 12 7 8 11 10 16 4 20 8" />
                </svg>
            )
        case "chart-line":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chart-area-line"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <polyline points="4 19 8 13 12 15 16 10 20 14 20 19 4 19" />
                    <polyline points="4 12 7 8 11 10 16 4 20 8" />
                </svg>
            )
        case "performance-compare":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chart-bar"
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 20h18" />
                    <rect x="5" y="12" width="4" height="8" rx="0.5" />
                    <rect x="10" y="6" width="4" height="14" rx="0.5" />
                    <rect x="15" y="9" width="4" height="11" rx="0.5" />
                </svg>
            )
        case "map-pin-color":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="30"
                    height="30"
                    viewBox="0 0 30 28"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle
                        r="15"
                        transform="matrix(1 0 0 -1 15 15)"
                        fill="#68ACFD"
                    />
                    <path
                        d="M21.545 13.545C21.545 18.636 15 23 15 23s-6.545-4.364-6.545-9.455a6.545 6.545 0 0 1 13.09 0Z"
                        fill="#fff"
                    />
                    <path
                        d="M15 15.727a2.182 2.182 0 1 0 0-4.363 2.182 2.182 0 0 0 0 4.363Z"
                        fill="#68ACFD"
                    />
                </svg>
            )
        case "dimensions":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#CC32F2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 5h11" />
                    <path d="M12 7l2 -2l-2 -2" />
                    <path d="M5 3l-2 2l2 2" />
                    <path d="M19 10v11" />
                    <path d="M17 19l2 2l2 -2" />
                    <path d="M21 12l-2 -2l-2 2" />
                    <rect
                        x="3"
                        y="10"
                        width="11"
                        height="11"
                        rx="2"
                        fill="#CC32F2"
                    />
                </svg>
            )
        case "person-color":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-user"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="7" r="4" />
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                </svg>
            )
        case "circle-down":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-arrow-down-circle"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#F86156"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="9" />
                    <line x1="8" y1="12" x2="12" y2="16" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="16" y1="12" x2="12" y2="16" />
                </svg>
            )
        case "help":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-help"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="9" />
                    <line x1="12" y1="17" x2="12" y2="17.01" />
                    <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
                </svg>
            )
        case "summary":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-chart-arcs"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#165cc4"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="12" cy="12" r="1" />
                    <path d="M16.924 11.132a5 5 0 1 0 -4.056 5.792" />
                    <path d="M3 12a9 9 0 1 0 9 -9" />
                </svg>
            )
        case "send":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-send"
                    width={size}
                    height={size}
                    stroke="#6C78B2"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                    <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
                </svg>
            )
        case "visit":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={size}
                    height={size}
                    fill="none"
                    stroke="#ffffff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    className="icon icon-tabler icon-tabler-list-numbers"
                    viewBox="0 0 24 24"
                >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M11 6h9M11 12h9M12 18h8M4 16a2 2 0 1 1 4 0c0 .591-.5 1-1 1.5L4 20h4M6 10V4L4 6" />
                </svg>
            )
        case "cancel":
            return (
                <svg
                    width="20"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="10" cy="10" r="10" fill="#FDE6E6" />
                    <path
                        d="m8 12 4-4M8 8l4 4"
                        stroke="#E46060"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case "activeCameras":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="50"
                    height="50"
                    viewBox="0 0 86 86"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="43" cy="43" r="43" fill="url(#a)" />
                    <path
                        fill="#84BD85"
                        fillRule="evenodd"
                        d="M27.423 32.406A4.886 4.886 0 0 1 30.857 31h13.357c1.288 0 2.524.506 3.435 1.406.91.9 1.422 2.121 1.422 3.394v8.428A8.979 8.979 0 0 0 46 51c0 1.186.23 2.318.646 3.355a4.902 4.902 0 0 1-2.432.645H30.857a4.886 4.886 0 0 1-3.434-1.406A4.772 4.772 0 0 1 26 50.2V35.8c0-1.273.512-2.494 1.423-3.394ZM60 43.516v-9.62c0-2.138-2.616-3.208-4.145-1.696L51.5 36.504v6.202A8.971 8.971 0 0 1 55 42c1.85 0 3.57.558 5 1.516Zm-8.5.781a7.528 7.528 0 0 1 3.5-.857c1.917 0 3.667.714 5 1.89v6.774c0 2.138-2.616 3.208-4.145 1.696L51.5 49.496v-5.199Zm-2.429 2.012V50.2a4.768 4.768 0 0 1-1.24 3.205A7.553 7.553 0 0 1 47.44 51c0-1.773.61-3.402 1.631-4.691Z"
                        clipRule="evenodd"
                    />
                    <circle cx="55" cy="51.001" r="7.56" fill="#84BD85" />
                    <path
                        fill="#fff"
                        stroke="#fff"
                        d="M58.357 48.811a.836.836 0 0 0-.553-.096.8.8 0 0 0-.498.293l-3.017 3.868-1.708-1.459-.006-.006-.007-.005a.824.824 0 0 0-.525-.176.82.82 0 0 0-.52.193.735.735 0 0 0-.262.544.733.733 0 0 0 .24.555l.007.006.007.005 2.36 2.016a.841.841 0 0 0 .913.103.78.78 0 0 0 .259-.213l3.539-4.537a.723.723 0 0 0 .136-.61.754.754 0 0 0-.365-.481Z"
                    />
                    <defs>
                        <linearGradient
                            id="a"
                            x1="43"
                            x2="43"
                            y1="0"
                            y2="86"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#E3F3E1" />
                            <stop offset="1" stopColor="#FEFFFE" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        case "companiesNumber":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="50"
                    height="50"
                    viewBox="0 0 86 86"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="43" cy="43" r="43" fill="url(#a)" />
                    <path
                        fill="#8865D1"
                        fillRule="evenodd"
                        d="M28.5 27c-.33 0-.65.13-.88.36a1.22 1.22 0 0 0 0 1.74c.23.23.55.36.88.36v27.08h-1.25c-.33 0-.65.13-.88.36a1.22 1.22 0 0 0 0 1.74c.23.23.55.36.88.36H48.5V29.46c.33 0 .65-.13.88-.36a1.22 1.22 0 0 0 0-1.74 1.26 1.26 0 0 0-.88-.36h-20Zm6.25 28.3v-3.68c0-.33.13-.64.37-.87.23-.24.55-.37.88-.37h5c.33 0 .65.13.88.37.24.23.37.54.37.87v3.69c0 .32-.13.64-.37.87-.23.23-.55.36-.88.36h-5c-.33 0-.65-.13-.88-.36a1.22 1.22 0 0 1-.37-.87ZM33.5 34.39c0-.32.13-.63.37-.87.23-.23.55-.36.88-.36H36c.33 0 .65.13.88.36a1.22 1.22 0 0 1 0 1.74c-.23.24-.55.37-.88.37h-1.25c-.33 0-.65-.13-.88-.37a1.22 1.22 0 0 1-.37-.87Zm1.25 3.7c-.33 0-.65.13-.88.36a1.22 1.22 0 0 0 0 1.74c.23.23.55.36.88.36H36c.33 0 .65-.13.88-.36a1.22 1.22 0 0 0 0-1.74 1.26 1.26 0 0 0-.88-.36h-1.25Zm-1.25 6.15c0-.33.13-.64.37-.87.23-.23.55-.36.88-.36H36c.33 0 .65.13.88.36a1.22 1.22 0 0 1 0 1.74c-.23.23-.55.36-.88.36h-1.25c-.33 0-.65-.13-.88-.36a1.22 1.22 0 0 1-.37-.87ZM41 33.15c-.33 0-.65.13-.88.36a1.22 1.22 0 0 0 0 1.74c.23.24.55.37.88.37h1.25c.33 0 .65-.13.88-.37a1.22 1.22 0 0 0 0-1.74 1.26 1.26 0 0 0-.88-.36H41Zm-1.25 6.16c0-.33.13-.64.37-.87.23-.23.55-.36.88-.36h1.25c.33 0 .65.13.88.36a1.22 1.22 0 0 1 0 1.74c-.23.23-.55.36-.88.36H41c-.33 0-.65-.13-.88-.36a1.22 1.22 0 0 1-.37-.87ZM41 43c-.33 0-.65.13-.88.36a1.22 1.22 0 0 0 0 1.74c.23.23.55.36.88.36h1.25c.33 0 .65-.13.88-.36a1.22 1.22 0 0 0 0-1.74 1.26 1.26 0 0 0-.88-.36H41Zm10-8.62V59h8.75c.33 0 .65-.13.88-.36a1.22 1.22 0 0 0 0-1.74 1.26 1.26 0 0 0-.88-.36H58.5v-19.7a1.22 1.22 0 0 0 .88-2.1 1.26 1.26 0 0 0-.88-.36H51Zm2.5 7.39c0-.33.13-.64.37-.87.23-.23.55-.36.88-.36h.01c.33 0 .65.13.89.36.23.23.36.54.36.87v.01c0 .33-.13.64-.36.87-.24.23-.56.36-.89.36h-.01c-.33 0-.65-.13-.88-.36a1.22 1.22 0 0 1-.37-.87v-.01Zm1.25 3.7a1.22 1.22 0 0 0-1.25 1.23c0 .68.56 1.24 1.25 1.24h.01c.33 0 .65-.13.89-.36.23-.24.36-.55.36-.87v-.02c0-.32-.13-.64-.36-.87a1.26 1.26 0 0 0-.89-.36h-.01Zm-1.25 6.15c0-.33.13-.64.37-.87.23-.24.55-.37.88-.37h.01c.33 0 .65.13.89.37a1.22 1.22 0 0 1 0 1.75c-.24.23-.56.36-.89.36h-.01c-.33 0-.65-.13-.88-.36a1.22 1.22 0 0 1-.37-.87v-.01Z"
                        clipRule="evenodd"
                    />
                    <defs>
                        <linearGradient
                            id="a"
                            x1="43"
                            x2="43"
                            y1="0"
                            y2="86"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#F3EEFB" />
                            <stop offset="1" stopColor="#FEFDFE" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        case "cameraModel":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="50"
                    height="50"
                    viewBox="0 0 86 86"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="43" cy="43" r="43" fill="url(#a)" />
                    <path
                        fill="#83ADF7"
                        d="M47.65 38.96a4.32 4.32 0 1 1-8.64 0 4.32 4.32 0 0 1 8.64 0Z"
                    />
                    <path
                        fill="#83ADF7"
                        d="M59.64 58.84c-.7-3.16-5.45-6.7-9.66-8.74a12.96 12.96 0 1 0-13.3 0c-4.2 2.05-8.95 5.58-9.66 8.74a.8.8 0 0 0 .77.97h3.26c.6.01 1.18-.12 1.72-.37 6.18-3.05 14.94-3.05 21.13 0 .53.25 1.12.38 1.71.37h3.26a.8.8 0 0 0 .77-.97ZM43.34 31.5a7.46 7.46 0 1 1 0 14.92 7.46 7.46 0 0 1 0-14.92Z"
                    />
                    <defs>
                        <linearGradient
                            id="a"
                            x1="43"
                            x2="43"
                            y1="0"
                            y2="86"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#E9F3FE" />
                            <stop offset="1" stopColor="#FBFDFF" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        case "cameraNumber":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="50"
                    height="50"
                    viewBox="0 0 86 86"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="43" cy="43" r="43" fill="url(#a)" />
                    <path
                        fill="#ECB54C"
                        d="M30.86 31c-1.3 0-2.53.5-3.44 1.4A4.77 4.77 0 0 0 26 35.8v14.4c0 1.27.51 2.5 1.42 3.4.91.9 2.15 1.4 3.44 1.4H44.2c1.3 0 2.53-.5 3.44-1.4a4.77 4.77 0 0 0 1.42-3.4V35.8c0-1.27-.51-2.5-1.42-3.4A4.89 4.89 0 0 0 44.2 31H30.86Zm25 22.8-4.36-4.3v-13l4.36-4.3c1.52-1.51 4.14-.44 4.14 1.7v18.2c0 2.14-2.62 3.21-4.14 1.7Z"
                    />
                    <defs>
                        <linearGradient
                            id="a"
                            x1="43"
                            x2="43"
                            y1="0"
                            y2="86"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#FCF6E1" />
                            <stop offset="1" stopColor="#FFFEFD" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        case "numInactiveCameras":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-dimensions"
                    width="50"
                    height="50"
                    viewBox="0 0 86 86"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="43" cy="43" r="43" fill="url(#a)" />
                    <path
                        fill="#DC6B5D"
                        d="M28.48 26.35a1.27 1.27 0 0 0-1.79.03 1.32 1.32 0 0 0-.03 1.82l30.86 31.38a1.29 1.29 0 0 0 1.42.32 1.28 1.28 0 0 0 .71-.72 1.33 1.33 0 0 0-.31-1.44L28.48 26.35ZM61 52.9c0 .82-.35 1.5-.86 1.96L52 46.57V35.9l4.61-4.7c1.62-1.64 4.39-.47 4.39 1.86v19.84ZM49.43 35.12v8.84L35.6 29.89h8.69a5.1 5.1 0 0 1 3.63 1.53c.97.98 1.5 2.31 1.5 3.7Zm-24.43 0c0-1.36.51-2.6 1.35-3.53l22.03 22.4a5.15 5.15 0 0 1-4.1 2.05H30.15a5.1 5.1 0 0 1-3.63-1.53 5.28 5.28 0 0 1-1.51-3.7V35.12Z"
                    />
                    <defs>
                        <linearGradient
                            id="a"
                            x1="43"
                            x2="43"
                            y1="0"
                            y2="86"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#FAECEA" />
                            <stop offset="1" stopColor="#FEFDFD" />
                        </linearGradient>
                    </defs>
                </svg>
            )
        case "greenArrow":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="none"
                >
                    <circle cx="15" cy="15" r="15" fill="#2ECC71" />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M15 22V9"
                    />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m10 14 5-5 5 5"
                    />
                </svg>
            )

        case "redArrow":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="none"
                >
                    <circle cx="15" cy="15" r="15" fill="#E74C3C" />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M15 8v13"
                    />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m10 16 5 5 5-5"
                    />
                </svg>
            )
        case "happyFace":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="none"
                >
                    <circle cx="15" cy="15" r="15" fill="#2ECC71" />
                    <circle cx="11" cy="13" r="1.5" fill="#FFF" />
                    <circle cx="19" cy="13" r="1.5" fill="#FFF" />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M10 17c1.5 2 3.2 3 5 3 1.8 0 3.5-1 5-3"
                    />
                </svg>
            )
        case "sadFace":
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="none"
                >
                    <circle cx="15" cy="15" r="15" fill="#E74C3C" />
                    <circle cx="11" cy="13" r="1.5" fill="#FFF" />
                    <circle cx="19" cy="13" r="1.5" fill="#FFF" />
                    <path
                        stroke="#FFF"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="M10 20c1.5-2 3.2-3 5-3 1.8 0 3.5 1 5 3"
                    />
                </svg>
            )
        default:
            return null
    }
}
